angular.module('rjmNg.api').factory("AdobeAnalytics", [
  "$q"
  "remoteDBConnectionService"
  "StructureCache"
  "utils"
  (
    $q
    remoteDBConnectionService
    StructureCache
    utils
  ) ->

    _localTableNames = {}

    _getGUID = () ->
      alphabet = 'abcdefghijklmnopqrstuvwxyz'
      utils.generateGUID(alphabet, 8)

    _getRemoteTableName = (guid) ->
      return "report_suite_#{guid}"

    # Right after the integration creation there is no information about
    # local tables yet, so we will use Remote Table Name for Local Table
    # Name as the default value
    _getLocalTableName = (guid, connectionMetaId) ->
      remoteTableName = _getRemoteTableName(guid)
      return _localTableNames[connectionMetaId]?[remoteTableName]?.localTableName ? remoteTableName

    _getTableId = (guid, connectionMetaId) ->
      remoteTableName = _getRemoteTableName(guid)
      return _localTableNames[connectionMetaId]?[remoteTableName]?.id

    ###
    For given connection id returns a promise which resolves in adding into
    _localTableNames object with following structure:
    ```
    {
      "remote-table-name-1": {
        "id": "table-id-1",
        "localTableName": "local-table-name-1"
      },
      ...
    }
    ```
    ###
    fetchLocalTableNames = (connectionMetaId) ->
      deferred = $q.defer()

      if _localTableNames[connectionMetaId]?
        deferred.resolve(connectionMetaId)
      else
        $q.all([
          remoteDBConnectionService.fetch(),
          StructureCache.getStructure()
        ]).then(
          ([remoteDBConnection, structure]) ->
            localTableNames = {}
            localTables = angular.copy(remoteDBConnectionService.localTables())
            structureTables = angular.copy(structure.tables)

            for id, table of localTables
              if table.connectionId is connectionMetaId
                localTableNames[table.name] =
                  id: id

            for name, table of localTableNames
              table.localTableName = structureTables[table.id]?.name

            _localTableNames[connectionMetaId] = localTableNames

            deferred.resolve(connectionMetaId)
          , (error) ->
            deferred.reject(error)
        )

      return deferred.promise

    makeReportSuite = (reportSuiteId, reportSuiteName, metrics, dimensions) ->
      guid = _getGUID()
      return
        guid: guid
        data:
          "report-suite-id": reportSuiteId
          "report-suite-name": reportSuiteName
          "metrics": metrics.sort()
          "dimensions": dimensions.sort()
        meta:
          remoteTableName: _getRemoteTableName(guid)
          localTableName: _getLocalTableName(guid, null)


    ###
    Before calling this function make sure that you called fetchLocalTableNames
    function to populate _localTableNames with data
    ###
    parseReportSuites = (connection) ->
      reportSuites = []
      if connection.properties?.report_suites?
        guids = JSON.parse(connection.properties.report_suites)
        for guid in guids
          data = JSON.parse(connection.properties[guid])
          meta =
            remoteTableName: _getRemoteTableName(guid)
            localTableName: _getLocalTableName(guid, connection.meta_id)
            tableId: _getTableId(guid, connection.meta_id)
          reportSuites.push({
            guid
            data
            meta
          })
      reportSuites

    {
      fetchLocalTableNames
      parseReportSuites
      makeReportSuite
    }
  ]
)
